import { searchRequest } from './searchQuery';

export default ({ namespace = 'default', code, model }) => async (
  filter,
  searchContext,
  options = {
    shouldCancel: false,
  },
) => {
  try {
    const response = await searchRequest({ namespace, code, model })(
      { searchContext, facets: [filter?.key] },
      options,
    );
    const { facets = [] } = response.data;
    const filterOptions = facets.reduce(
      (acc, facet) => ({
        ...acc,
        [facet.key]: facet.buckets.map(bucket => ({ label: bucket.value, value: bucket.value })),
      }),
      {},
    );

    return filterOptions[filter.key] || [];
  } catch (err) {
    return Promise.reject(err);
  }
};
